export default "__VITE_ASSET__GBNxIgQz__"